import { t } from 'i18next';
import { useEffect, useState } from 'react';

import CreateProjectDropdown from '../../../components/DropdownStyle/CreateProjectDropdown';
import ComponentCircleLoader from '../../../components/Loaders/ComponentCircleLoader';
import ReactSelectDropdown from '../../../components/ReactSelectDropdown';
import { filterOption } from '../../../components/ReactSelectDropdown/ReactSelectDropdown';
import {
  CommonFlex,
  CommonText,
  Container,
  FilterLabel,
  InputWithLabelSection,
  PageTitle,
} from '../../../styledComponents/common';
import CampReadinessChart from './CampReadinessChart';

const CampReadiness = ({
  officesShortList,
  itemsList,
  getOfficesShortList,
  getItemsList,
  campReadinessDashboardData = [],
  getCampReadinessDashboardData,
  isLoading,
}) => {
  const [selectedOffice, setSelectedOffice] = useState({
    label: t('all_offices'),
    value: null,
  });

  const [officeOptions, setOfficeOptions] = useState([
    { label: t('all_offices'), value: null },
  ]);

  useEffect(() => {
    getOfficesShortList();
  }, []);

  useEffect(() => {
    const payload = {};
    if (selectedOffice?.value) {
      payload.office_id = selectedOffice.value;
    }
    getCampReadinessDashboardData(payload);
  }, [selectedOffice]);

  useEffect(() => {
    if (officesShortList?.length) {
      const options = [
        { label: t('all_offices'), value: null },
        ...officesShortList.map(office => ({
          label: office.name,
          value: office.id,
        })),
      ];
      setOfficeOptions(options);
    }
  }, [officesShortList]);

  return (
    <div className="content">
      <Container padding="30px">
        <CommonText name title fontSize="20px">
          {t('camp_readiness_dashboard')}
        </CommonText>
        <CommonFlex gap="20px" margin="20px 0">
          <InputWithLabelSection
            width="200px"
            style={{
              zIndex: 6,
            }}
          >
            <FilterLabel>{t('office')}</FilterLabel>
            <ReactSelectDropdown
              isSearchable={false}
              value={selectedOffice}
              options={officeOptions}
              placeholder={t('select_office')}
              onChange={setSelectedOffice}
              styles={CreateProjectDropdown()}
              filterOption={filterOption}
            />
          </InputWithLabelSection>
        </CommonFlex>
        {isLoading ? (
          <ComponentCircleLoader />
        ) : (
          <CampReadinessChart
            campReadinessDashboardData={campReadinessDashboardData}
          />
        )}
      </Container>
    </div>
  );
};

export default CampReadiness;
